import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FORGOT_PASSWORD_REQUEST,
  forgotPasswordSuccess,
  forgotPasswordFailure,
} from './actions';
import { push } from 'connected-react-router';
import { post } from '../../utils/api';
import swal from 'sweetalert';

function* forgotPasswordRequest({ payload }) {
  try {
    yield call(
      post,
      '/forgot-password-create-otp',
      { email: payload.email },
      null,
      'account'
    );
    yield put(forgotPasswordSuccess());
    yield call(swal, 'Success', 'OTP code sent to your email', 'success');
    yield put(push('/login'));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || 'Failed to send OTP';
    yield call(swal, 'Error', errorMessage, 'error');
    yield put(forgotPasswordFailure(errorMessage));
  }
}

export default [takeLatest(FORGOT_PASSWORD_REQUEST, forgotPasswordRequest)];
